export default "__VITE_ASSET__B0Jp_f2w__"